module.exports = __webpack_public_path__ + "img/bos1.bdc837e9.png";